'use client'

import React from 'react'
import Image from 'next/image'

export function ServicesSection() {
  const services = [
    {
      title: 'Doula Support',
      description:
        'Navigate pregnancy and birth with a trusted guide and expert. Learn how doula care helps you have a safer, more supported childbirth experience.',
    },
    {
      title: 'Postpartum and Newborn Care',
      description:
        'After birth, everyone needs some support. Finding your qualified newborn specialist, overnight care, postpartum doulas and more is now easier and safer than ever before.',
    },
    {
      title: 'First Year Specialists and Childcare',
      description:
        'Looking for infant sleep experts, special needs care, sibling care during labor, short-term or emergency childcare?',
    },
    {
      title: 'Lactation Services',
      description:
        "Lactation specialists are key to making sure you're feeding your baby without pain or worry. Insurance covers most services.",
    },
    {
      title: 'Mental Health Services',
      description:
        'Find our vetted experts who specialize in supporting emotional wellbeing in the time surrounding pregnancy and parenting.',
    },
  ]

  return (
    <section
      data-component-name="ServicesSection"
      style={{
        backgroundColor: '#f5f0eb',
        position: 'relative',
        padding: '120px 0',
      }}
    >
      {/* Decorative red clip - temporarily hidden
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: '100px',
          width: '200px',
          height: '200px',
          pointerEvents: 'none',
        }}
      >
        <Image
          src="/images/red-left-clip.svg"
          alt=""
          width={200}
          height={200}
          style={{
            width: '100%',
            height: 'auto',
          }}
        />
      </div>
      */}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left Column */}
          <div>
            {/* Service Image */}
            <div style={{ marginBottom: '40px' }}>
              <Image
                src="/images/services-baby-image.jpg"
                alt="Baby care"
                width={600}
                height={400}
                style={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '8px',
                }}
              />
            </div>

            {/* Heading */}
            <h5
              style={{
                fontSize: '20px',
                fontFamily: 'var(--font-sulsans-medium)',
                fontWeight: '400',
                color: '#3a4e3d',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                marginBottom: '10px',
              }}
            >
              Your Circle of Support
            </h5>

            <h2
              style={{
                fontSize: '49px',
                fontFamily: 'var(--font-copernicus)',
                fontWeight: '400',
                color: '#071C26',
                letterSpacing: '-1px',
                marginBottom: '20px',
              }}
            >
              Services
            </h2>

            {/* Description */}
            <p
              style={{
                fontSize: '15px',
                fontFamily: 'var(--font-sulsans-light)',
                fontWeight: '400',
                color: '#071C26',
                lineHeight: '22px',
                marginBottom: '30px',
              }}
            >
              If you know what services you&apos;re interested in exploring, matching and scheduling
              with an available provider today is now within reach. If you don&apos;t know what
              support may be right for you,{' '}
              <a
                href="/find-doula/contact"
                style={{
                  color: '#071C26',
                  fontFamily: 'var(--font-sulsans-medium)',
                  textDecoration: 'none',
                }}
              >
                connect with a Care Expert today
              </a>
              .
            </p>

            {/* CTA Button */}
            <a
              href="/search"
              style={{
                display: 'inline-block',
                fontSize: '15px',
                fontFamily: 'var(--font-copernicus)',
                fontWeight: '400',
                color: 'rgb(255, 255, 255)',
                backgroundColor: 'rgb(58, 78, 61)',
                padding: '20px 40px',
                borderRadius: '40px',
                border: 'none',
                textDecoration: 'none',
                transition: 'transform 0.3s, box-shadow 0.3s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = 'none'
              }}
            >
              Schedule a Free Consultation
            </a>
          </div>

          {/* Right Column - Service Cards */}
          <div>
            {services.map((service, index) => (
              <div
                key={index}
                style={{
                  marginBottom: index < services.length - 1 ? '40px' : '0',
                }}
              >
                <h3
                  style={{
                    fontSize: '24px',
                    fontFamily: 'var(--font-copernicus)',
                    fontWeight: '400',
                    color: '#071C26',
                    marginBottom: '10px',
                  }}
                >
                  {service.title}
                </h3>
                <p
                  style={{
                    fontSize: '15px',
                    fontFamily: 'var(--font-sulsans-light)',
                    fontWeight: '400',
                    color: '#071C26',
                    lineHeight: '22px',
                  }}
                >
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
